var map = {
	"./1/symbol_0.png": 11154,
	"./1/symbol_1.png": 32699,
	"./1/symbol_10_x10.png": 68897,
	"./1/symbol_10_x100.png": 39829,
	"./1/symbol_10_x1000.png": 37937,
	"./1/symbol_10_x12.png": 93523,
	"./1/symbol_10_x15.png": 38652,
	"./1/symbol_10_x2.png": 67438,
	"./1/symbol_10_x20.png": 25324,
	"./1/symbol_10_x25.png": 58577,
	"./1/symbol_10_x250.png": 36293,
	"./1/symbol_10_x3.png": 13015,
	"./1/symbol_10_x4.png": 64024,
	"./1/symbol_10_x5.png": 85153,
	"./1/symbol_10_x50.png": 99189,
	"./1/symbol_10_x500.png": 43729,
	"./1/symbol_10_x6.png": 54570,
	"./1/symbol_10_x8.png": 14484,
	"./1/symbol_2.png": 51488,
	"./1/symbol_3.png": 75689,
	"./1/symbol_4.png": 25718,
	"./1/symbol_5.png": 63167,
	"./1/symbol_6.png": 77892,
	"./1/symbol_7.png": 41133,
	"./1/symbol_8.png": 65869,
	"./1/symbol_9.png": 78083,
	"./slotmachine_free.png": 49927,
	"./slotmachine_normal.png": 54092
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55124;